<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <!-- <router-view/> -->
  </div>
</template>

<script>
import "babel-polyfill";
export default {
  name: "App"
};
</script>

<style>
body,
html {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  font-family: "Source Han Sans CN", "Microsoft YaHei", "微软雅黑", "Avenir",
    "Helvetica", "Arial", "sans-serif" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
#app {
  height: 100%;
  width: 100%;
  position: relative;
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.flex-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1580px) {
  #app {
    min-width: 1200px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1580px) {
  #app {
    min-width: 1380px;
    margin: 0 auto;
  }
}

.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: 0.5s;
}
.v-enter-to {
  opacity: 1;
}
.v-leave {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
.v-leave-active {
  transition: 0.5s;
}

/* 轮播组件样式 */
.ic-slider {
  overflow: hidden;
  position: relative;
  user-select: none;
  cursor: pointer;
}
.ic-slider .ic-slider-item {
  float: left;
  height: 100%;
}
.ic-slider .ic-slider-item div {
  width: 100%;
  height: 500px;
}
.ic-slider .ic-slider__track {
  height: 100%;
  overflow: hidden;
}
.ic-slider__indicators {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 12px;
  transform: translateZ(1px);
  text-align: center;
  font-size: 0;
}
.ic-slider__indicators > i {
  display: inline-block;
  margin: 0 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
}
.ic-slider__indicators .ic-slider__indicator--active {
  width: 20px;
  border-radius: 5px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue